import styled from 'styled-components';

import Button from '../Button';
import {
  modalButtonContainerStyle,
  modalButtonPrimaryStyle,
  modalButtonSecondaryStyle,
  modalContainerStyle,
  modalStyle,
} from '../../constants/modals';
import colors from '../../styles/colors';

const Container = styled.div`
  ${modalContainerStyle}
`;

const StyledModal = styled.div`
  ${modalStyle}
`;

const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 4px;
`;

const Subtitle = styled.div`
  font-size: 14px;
  line-height: 1.4;
  color: ${colors.shades.gamma7};
  padding-bottom: 12px;
`;

const AssigneeList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 240px;
  overflow-y: auto;
  padding: 4px 0;
`;

const AssigneeItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 12px;
  border-radius: 8px;
  border: 1.5px solid ${({ $selected }) => ($selected ? colors.base.secondary : colors.shades.gamma3)};
  background-color: ${({ $selected }) => ($selected ? colors.shades.secondary10 : 'transparent')};
  cursor: pointer;
  text-align: left;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background-color: ${({ $selected }) => ($selected ? colors.shades.secondary5 : colors.shades.gamma1)};
  }
`;

const AssigneeName = styled.span`
  font-size: 14px;
  font-weight: ${({ $selected }) => ($selected ? 'bold' : 'normal')};
  color: ${colors.base.beta};
`;

const AssigneeRole = styled.span`
  font-size: 12px;
  color: ${colors.shades.gamma7};
`;

const LoadingSpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  padding: 8px 0;
`;

const ControlsContainer = styled.div`
  display: flex;
  justify-content: end;
  width: 100%;
  padding-top: 16px;
`;

const StyledButtonContainer = styled.div`
  ${modalButtonContainerStyle}
`;

const StyledSecondaryButton = styled(Button)`
  ${modalButtonSecondaryStyle}
`;

const StyledPrimaryButton = styled(Button)`
  ${modalButtonPrimaryStyle}
  opacity: ${({ disabled }) => (disabled ? 0.4 : 1)};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export {
  Container,
  StyledModal,
  Title,
  Subtitle,
  AssigneeList,
  AssigneeItem,
  AssigneeName,
  AssigneeRole,
  LoadingSpinnerContainer,
  ControlsContainer,
  StyledButtonContainer,
  StyledSecondaryButton,
  StyledPrimaryButton,
};
